<ion-header>
    <ion-toolbar>
        <ion-title>Items to be collected</ion-title>
        <ion-buttons slot="start">
            <ion-button (tap)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (tap)="scanCode()">
                <ion-icon slot="icon-only" name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item>
        <ion-input [(ngModel)]="manualInput" placeholder="Manual barcode input"></ion-input>
        <ion-button slot="end" (click)="handleScanResult(manualInput)" [disabled]="!manualInput" color="light">
            <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
    </ion-item>
    <ion-list>
        <ion-item *ngFor="let line of collectionDetailLines">
            <ion-label [color]="line.qty < line.requiredQty ? 'danger' : 'success'">
                <p>{{line.qty + ' of ' + line.requiredQty}} - {{line.description}}</p>
                <p>{{line.pdesc + ' - ' + line.reg}}</p>
            </ion-label>
        </ion-item>
    </ion-list>

<!--    <ion-fab vertical="bottom" horizontal="end" slot="fixed">-->
<!--        <ion-fab-button (tap)="scanCode()" color="success">-->
<!--            <ion-icon name="checkmark"></ion-icon>-->
<!--        </ion-fab-button>-->
<!--    </ion-fab>-->
</ion-content>
